import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import InvoiceBatch from '../../entities/invoiceBatch';
export function deleteInvoiceBatch(invoiceBatch: InvoiceBatch, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = invoiceBatch.id;}
const _work = workingSet();




invoiceBatch.status = 'D';
invoiceBatch.addedOn = newHRTimestamp();
invoiceBatch.addedBy = getCurrentUserId();
invoiceBatch.importSource = targetImportSource;
invoiceBatch.importId = mergeId;
store.dispatch(Actions.InvoiceBatchActions.removeInvoiceBatchQueue(invoiceBatch));
}


